const VERSION = "13.5.0";
export {
  VERSION
};
//# sourceMappingURL=version.js.map
